'use client';

import type { UseScrollProgress, UseScrollProgressReturn } from '@/core/types';

import { useRef, useMemo } from 'react';
import { useScroll } from 'framer-motion';

export function useScrollProgress(target: UseScrollProgress = 'document'): UseScrollProgressReturn {
  // Change the type assertion to indicate the ref will never be null
  const elementRef = useRef<HTMLDivElement>(null!) as React.RefObject<HTMLDivElement>;

  const options = { container: elementRef };

  const { scrollYProgress, scrollXProgress } = useScroll(
    target === 'container' ? options : undefined
  );

  const memoizedValue = useMemo(
    () => ({ elementRef, scrollXProgress, scrollYProgress }),
    [elementRef, scrollXProgress, scrollYProgress]
  );

  return memoizedValue;
}
